import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { Box, Grid, Stack, Button, DialogContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { WsColors, WsDrawer, WsTypoColors } from 'wisestep-base';

import CountDownTime from '../../auth/components/CountDownTime';

const stagedIcon = {
  fontSize: '100px',
  mr: 1,
  cursor: 'pointer',
};

const PayementConfirmation = ({
  success,
  updated,
  onClose,
}: {
  success: boolean;
  updated: boolean;
  onClose?: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <WsDrawer size="full" open={true} onClose={() => navigate('/home')}>
      <DialogContent>
        <Grid container>
          <Grid item xs={22} mt={7} sx={{ textAlign: 'center' }}>
            {success ? (
              <>
                <CheckCircleRoundedIcon sx={{ ...stagedIcon, color: WsColors.Green500 }} />
                <Stack direction="column" spacing={2}>
                  <Typography variant="h4" sx={{ fontWeight: 'bold' }} color={WsTypoColors.GREEN}>
                    Payment Successful
                  </Typography>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Thank you for choosing Wisestep.
                  </Typography>
                  <Typography variant="h5">{`Your plan is ${
                    updated ? 'updated' : 'activated'
                  } now`}</Typography>
                </Stack>
                <Box mt={2}>
                  <Button
                    variant="outlined"
                    sx={{ borderColor: WsColors.Green500, color: WsColors.Green500 }}
                    onClick={() => {
                      window.location.href = `${window.location.origin}/app-settings/plan-details`;
                    }}
                  >
                    Continue
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <ErrorRoundedIcon sx={{ ...stagedIcon, color: WsColors.Red500 }} />
                <Stack direction="column" spacing={2}>
                  <Typography variant="h4" sx={{ fontWeight: 700 }} color={WsTypoColors.RED}>
                    Payment Failed
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700 }}
                  >{`Your transaction couldn't be processed`}</Typography>
                </Stack>
                <Box mt={2}>
                  <Button
                    variant="outlined"
                    sx={{ borderColor: WsColors.Red500, color: WsColors.Red500 }}
                    onClick={() => {
                      onClose ? onClose() : navigate('/plan/purchase');
                    }}
                  >
                    Try Again
                  </Button>
                </Box>
              </>
            )}
          </Grid>
          <Grid item xs={12} mt={16} textAlign="center">
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Auto redirecting in
            </Typography>

            <Box mt={3}>
              <CountDownTime
                seconds={10}
                size={60}
                strokeBgColor={WsColors.White}
                strokeColor={WsColors.TheBlues500}
                strokeWidth={4}
                onExpiry={() => {
                  if (success) {
                    window.location.href = `${window.location.origin}/app-settings/plan-details`;
                  } else {
                    navigate('/plan/purchase');
                  }
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </WsDrawer>
  );
};

export default PayementConfirmation;
